import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

/**
 * Resolve a file URL - returns the full URL for absolute URLs (http:// or https://),
 * or prepends the base URL for relative paths.
 * Handles edge cases like malformed protocols (e.g. "https//" missing colon).
 */
export function resolveFileUrl(url, baseUrl) {
  if (!url) return '';
  // Only treat as absolute if it has a proper protocol with "://"
  if (url.startsWith('http://') || url.startsWith('https://')) {
    return url;
  }
  return `${baseUrl || ''}${url}`;
}
